"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.attackedPools = void 0;
exports.userCollectCetusCompensationAll = userCollectCetusCompensationAll;
exports.userCollectCetusCompensation = userCollectCetusCompensation;
exports.getUserCompensationAmountAll = getUserCompensationAmountAll;
exports.getUserCompensationAmount = getUserCompensationAmount;
const alphafi_sdk_1 = require("@alphafi/alphafi-sdk");
const transactions_1 = require("@mysten/sui/transactions");
const bcs_1 = require("@mysten/sui/bcs");
exports.attackedPools = [
    "WETH-WUSDC",
    "WUSDC-WBTC",
    "USDC-ETH",
    "BUCK-SUI",
    "USDC-WUSDC",
    "USDC-SUIUSDT",
    "WUSDC-SUI",
    "FUD-SUI",
    "ALPHA-SUI",
    "NAVX-SUI",
    "USDT-WUSDC",
    "CETUS-SUI",
    "USDC-USDT",
    "DEEP-SUI",
    "USDC-SUI",
];
async function userCollectCetusCompensationAll(address) {
    let txb = new transactions_1.Transaction();
    for (const poolName of exports.attackedPools) {
        const tx = await userCollectCetusCompensation(poolName, address, txb);
        if (tx) {
            txb = tx;
        }
    }
    return txb;
}
async function userCollectCetusCompensation(poolName, address, tx) {
    let txb;
    if (tx) {
        txb = tx;
    }
    else {
        txb = new transactions_1.Transaction();
    }
    const poolData = alphafi_sdk_1.poolInfo[poolName];
    const coinAName = alphafi_sdk_1.doubleAssetPoolCoinMap[poolName].coin1;
    const coinBName = alphafi_sdk_1.doubleAssetPoolCoinMap[poolName].coin2;
    const coinA = alphafi_sdk_1.coinsList[coinAName];
    const coinB = alphafi_sdk_1.coinsList[coinBName];
    const receipt = await (0, alphafi_sdk_1.getReceipts)(poolName, address, false);
    if (!receipt || receipt.length == 0) {
        console.error("no receipt", poolName);
        return undefined;
    }
    let cetusCoin;
    if (coinBName === "SUI" && poolName != "CETUS-SUI") {
        cetusCoin = txb.moveCall({
            target: `${(0, alphafi_sdk_1.getConf)().ALPHA_CETUS_COMPENSATOR_LATEST_PACKAGE_ID}::alphafi_cetus_compensation::user_collect_cetus_compensation_sui`,
            typeArguments: [alphafi_sdk_1.coinsList[coinAName].type, coinB.type],
            arguments: [
                txb.object((0, alphafi_sdk_1.getConf)().ALPHA_CETUS_COMPENSATOR_VERSION),
                txb.object((0, alphafi_sdk_1.getConf)().ALPHA_CETUS_COMPENSATOR),
                txb.object(receipt[0].objectId),
                txb.object(poolData.poolId),
            ],
        });
    }
    else if (poolName === "WUSDC-WBTC" ||
        poolName === "USDC-USDT" ||
        poolName === "USDC-WUSDC" ||
        poolName === "USDC-ETH") {
        cetusCoin = txb.moveCall({
            target: `${(0, alphafi_sdk_1.getConf)().ALPHA_CETUS_COMPENSATOR_LATEST_PACKAGE_ID}::alphafi_cetus_compensation::user_collect_cetus_compensation_base_a`,
            typeArguments: [alphafi_sdk_1.coinsList[coinAName].type, coinB.type],
            arguments: [
                txb.object((0, alphafi_sdk_1.getConf)().ALPHA_CETUS_COMPENSATOR_VERSION),
                txb.object((0, alphafi_sdk_1.getConf)().ALPHA_CETUS_COMPENSATOR),
                txb.object(receipt[0].objectId),
                txb.object(poolData.poolId),
            ],
        });
    }
    else if (poolName === "CETUS-SUI") {
        cetusCoin = txb.moveCall({
            target: `${(0, alphafi_sdk_1.getConf)().ALPHA_CETUS_COMPENSATOR_LATEST_PACKAGE_ID}::alphafi_cetus_compensation::user_collect_cetus_compensation_cetus_sui`,
            typeArguments: [alphafi_sdk_1.coinsList[coinAName].type, coinB.type],
            arguments: [
                txb.object((0, alphafi_sdk_1.getConf)().ALPHA_CETUS_COMPENSATOR_VERSION),
                txb.object((0, alphafi_sdk_1.getConf)().ALPHA_CETUS_COMPENSATOR),
                txb.object(receipt[0].objectId),
                txb.object(poolData.poolId),
            ],
        });
    }
    else {
        cetusCoin = txb.moveCall({
            target: `${(0, alphafi_sdk_1.getConf)().ALPHA_CETUS_COMPENSATOR_LATEST_PACKAGE_ID}::alphafi_cetus_compensation::user_collect_cetus_compensation`,
            typeArguments: [alphafi_sdk_1.coinsList[coinAName].type, coinB.type],
            arguments: [
                txb.object((0, alphafi_sdk_1.getConf)().ALPHA_CETUS_COMPENSATOR_VERSION),
                txb.object((0, alphafi_sdk_1.getConf)().ALPHA_CETUS_COMPENSATOR),
                txb.object(receipt[0].objectId),
                txb.object(poolData.poolId),
            ],
        });
    }
    txb.transferObjects([cetusCoin], address);
    return txb;
    // dryRunTransactionBlock(txb);
    // executeTransactionBlock(txb);
}
async function getUserCompensationAmountAll(address) {
    const data = {};
    let totalCetusTokens = 0;
    for (const poolName of exports.attackedPools) {
        const amount = await getUserCompensationAmount(poolName, address);
        const receiptId = await (0, alphafi_sdk_1.getReceipts)(poolName, address, false);
        data[poolName] = {
            amount: Number(amount),
            receiptId: receiptId && receiptId.length > 0 && receiptId[0]?.objectId
                ? receiptId[0].objectId
                : "",
        };
        totalCetusTokens += Number(amount);
    }
    return [data, totalCetusTokens];
}
async function getUserCompensationAmount(poolName, address) {
    const txb = new transactions_1.Transaction();
    const poolData = alphafi_sdk_1.poolInfo[poolName];
    const coinAName = alphafi_sdk_1.doubleAssetPoolCoinMap[poolName].coin1;
    const coinBName = alphafi_sdk_1.doubleAssetPoolCoinMap[poolName].coin2;
    const coinA = alphafi_sdk_1.coinsList[coinAName];
    const coinB = alphafi_sdk_1.coinsList[coinBName];
    const receipt = await (0, alphafi_sdk_1.getReceipts)(poolName, address, false);
    if (!receipt || receipt.length == 0) {
        console.error("no receipt", poolName);
        return "0";
    }
    let cetusAmount;
    if (coinBName === "SUI" && poolName != "CETUS-SUI") {
        cetusAmount = txb.moveCall({
            target: `${(0, alphafi_sdk_1.getConf)().ALPHA_CETUS_COMPENSATOR_LATEST_PACKAGE_ID}::alphafi_cetus_compensation::get_user_compensation_amount_sui`,
            typeArguments: [alphafi_sdk_1.coinsList[coinAName].type, coinB.type],
            arguments: [
                txb.object((0, alphafi_sdk_1.getConf)().ALPHA_CETUS_COMPENSATOR),
                txb.object(receipt[0].objectId),
                txb.object(poolData.poolId),
            ],
        });
    }
    else if (poolName === "WUSDC-WBTC" ||
        poolName === "USDC-USDT" ||
        poolName === "USDC-WUSDC" ||
        poolName === "USDC-ETH") {
        txb.moveCall({
            target: `${(0, alphafi_sdk_1.getConf)().ALPHA_CETUS_COMPENSATOR_LATEST_PACKAGE_ID}::alphafi_cetus_compensation::get_user_compensation_amount_base_a`,
            typeArguments: [alphafi_sdk_1.coinsList[coinAName].type, coinB.type],
            arguments: [
                txb.object((0, alphafi_sdk_1.getConf)().ALPHA_CETUS_COMPENSATOR),
                txb.object(receipt[0].objectId),
                txb.object(poolData.poolId),
            ],
        });
    }
    else if (poolName === "CETUS-SUI") {
        txb.moveCall({
            target: `${(0, alphafi_sdk_1.getConf)().ALPHA_CETUS_COMPENSATOR_LATEST_PACKAGE_ID}::alphafi_cetus_compensation::get_user_compensation_amount_cetus_sui`,
            typeArguments: [alphafi_sdk_1.coinsList[coinAName].type, coinB.type],
            arguments: [
                txb.object((0, alphafi_sdk_1.getConf)().ALPHA_CETUS_COMPENSATOR),
                txb.object(receipt[0].objectId),
                txb.object(poolData.poolId),
            ],
        });
    }
    else {
        txb.moveCall({
            target: `${(0, alphafi_sdk_1.getConf)().ALPHA_CETUS_COMPENSATOR_LATEST_PACKAGE_ID}::alphafi_cetus_compensation::get_user_compensation_amount`,
            typeArguments: [alphafi_sdk_1.coinsList[coinAName].type, coinB.type],
            arguments: [
                txb.object((0, alphafi_sdk_1.getConf)().ALPHA_CETUS_COMPENSATOR),
                txb.object(receipt[0].objectId),
                txb.object(poolData.poolId),
            ],
        });
    }
    const ok = await (0, alphafi_sdk_1.getSuiClient)().devInspectTransactionBlock({
        sender: address,
        transactionBlock: txb,
    });
    if (!ok.results) {
        return "0";
    }
    const res = ok.results[0].returnValues[0][0];
    const deserializedRes = bcs_1.bcs.u64().parse(Uint8Array.from(res));
    return deserializedRes ? deserializedRes : "0";
}
//# sourceMappingURL=index.js.map